import React, { Fragment, useEffect } from 'react';
import { initCanvas, initTemplateCode } from './../CanvasActions';

const FrontCanvas = React.memo((props) => {
    /* componentDidMount */
    useEffect(() => {
        if (props.brochure == null || parseInt(props.brochure.id) !== 12) {
            return;
        }
        initTemplateCode('p16bt12');
        initCanvas();
    }, [props.brochure]);

    if (props.brochure == null) {
        return null;
    }

    let backImage = (
        <div>
            <h6 className="mt-4">Back</h6>
            <div className="preview-image">
                <img src={props.brochure.back_image_url} alt="Brochure" />
            </div>
        </div>
    );
    let title = <h5>{props.brochure.name}</h5>;
    let frontTitle = <h6>Front</h6>;
    if (parseInt(props.brochure.id) === 2 || [3, 4, 5, 6, 7, 9, 10, 13, 14].includes(parseInt(props.brochure.id))) {
        backImage = null;
        title = null;
        frontTitle = null;
    }

    const renderAdditionalImages = () => {
        if (parseInt(props.brochure.id) !== 11) {
            return null;
        }

        return (
            <Fragment>
                <div>
                    <h6 className="mt-4">Page 2-3</h6>
                    <div className="preview-image">
                        <img src="https://ac-ut-health.s3.amazonaws.com/brochures-images/health-screenings-brochure-Pg2-3-low.jpg" alt="Brochure" />
                    </div>
                </div>
                <div>
                    <h6 className="mt-4">Page 4-5</h6>
                    <div className="preview-image">
                        <img src="https://ac-ut-health.s3.amazonaws.com/brochures-images/health-screenings-brochure-Pg4-5-low.jpg" alt="Brochure" />
                    </div>
                </div>
                <div>
                    <h6 className="mt-4">Page 6-7</h6>
                    <div className="preview-image">
                        <img src="https://ac-ut-health.s3.amazonaws.com/brochures-images/health-screenings-brochure-Pg6-7-low.jpg" alt="Brochure" />
                    </div>
                </div>
            </Fragment>
        );
    };

    let frontImage = (
        <div>
            {frontTitle}
            <div className="preview-image front-preview">
                <img src={props.brochure.front_image_url} alt="Brochure" />
            </div>
        </div>
    );

    let canvasStyle = {};
    // canvasStyle.visibility = 'hidden';
    let className = ' hidden';
    if (parseInt(props.brochure.id) === 12) {
        className = '';
        backImage = (
            <div>
                <h6 className="mt-4">Back</h6>
                <div className="big-image">
                    <img src={props.brochure.back_image_url} alt="Brochure" />
                </div>
            </div>
        );
        
        if (parseInt(props.type) === 1) {
            frontImage = (
                <div>
                    {frontTitle}
                    <div className="big-image front-preview">
                        <img src={props.brochure.front_image_url} alt="Brochure" />
                    </div>
                </div>
            );
            // className = ' hidden';
            // canvasStyle.visibility = 'hidden';
            canvasStyle.display = 'none';
        } else {
            frontImage = null;
            // className = '';
            // canvasStyle.visibility = '';
            canvasStyle.display = 'block';
        }
    }

    return (
        <div className="front-canvas-container">
            {title}
            <div className="horizontal-container">
                {frontImage}
                <div id={'front-canvas' + className} style={canvasStyle}></div>
                {renderAdditionalImages()}
                {backImage}
            </div>
        </div>
    );
});

export default FrontCanvas;
